import { PersonalInformationFormProps } from "./personal-information-form.types";
import { PersonalInformationFormView } from "./personal-information-form-view";
import { usePersonalInformationForm } from "./use-personal-information-form";

export const PersonalInformationForm: React.FC<PersonalInformationFormProps> = ({ formId }) => {
  const logic = usePersonalInformationForm();

  return <PersonalInformationFormView formId={formId} {...logic} />;
};
